
(() => {
  const STYLE_ID = 'firefly-popup-celebration-styles';

  function addFireflies(shadowRoot) {
    const heading = [...shadowRoot.querySelectorAll('h1, h2, h3')]
      .find(el => el.textContent.trim() === "You're in the Parade!");

    if (!heading || heading.dataset.firefliesAdded === 'true') return;

    heading.dataset.firefliesAdded = 'true';
    heading.classList.add('firefly-popup-heading');

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      .firefly-popup-heading {
        position: relative;
      }

      .firefly-popup-spark {
        position: absolute;
        width: 7px;
        height: 7px;
        border-radius: 50%;
        background: #ffd76a;
        box-shadow:
          0 0 6px #ffd76a,
          0 0 12px rgba(255, 215, 106, 0.9),
          0 0 20px rgba(255, 191, 64, 0.55);
        opacity: 0;
        pointer-events: none;
        animation: firefly-popup-float 2.4s ease-out forwards;
      }

      .firefly-popup-spark--one {
        left: 38%;
        top: 50%;
        animation-delay: 1.1s;
        --drift: -20px;
      }

      .firefly-popup-spark--two {
        left: 62%;
        top: 50%;
        animation-delay: 1.35s;
        --drift: 20px;
      }

      @keyframes firefly-popup-float {
        0% {
          transform: translate(0, 0) scale(0.4);
          opacity: 0;
        }
        30% {
          transform: translate(calc(var(--drift) * 0.4), -8px) scale(1);
          opacity: 1;
        }
        65% {
          transform: translate(calc(var(--drift) * 0.7), -14px) scale(0.8);
          opacity: 0.8;
        }
        100% {
          transform: translate(var(--drift), -20px) scale(0.5);
          opacity: 0;
        }
      }

      @media (prefers-reduced-motion: reduce) {
        .firefly-popup-spark {
          animation: none;
        }
      }
    `;

    if (!shadowRoot.getElementById(STYLE_ID)) {
      shadowRoot.appendChild(style);
    }

    for (const number of ['one', 'two']) {
      const spark = document.createElement('span');
      spark.className = `firefly-popup-spark firefly-popup-spark--${number}`;
      spark.setAttribute('aria-hidden', 'true');
      heading.appendChild(spark);
    }
  }

  function watchPopup(host) {
    if (!host.shadowRoot || host.dataset.fireflyWatcher === 'true') return;

    host.dataset.fireflyWatcher = 'true';

    const observer = new MutationObserver(() => {
      addFireflies(host.shadowRoot);
    });

    observer.observe(host.shadowRoot, {
      childList: true,
      subtree: true
    });

    addFireflies(host.shadowRoot);
  }

  function findPopups() {
    document.querySelectorAll('shopify-forms-embed').forEach(watchPopup);
  }

  const pageObserver = new MutationObserver(findPopups);

  function initialize() {
    findPopups();
    pageObserver.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
